// @ts-strict-ignore
import { WxShape } from './wx-shape';
import { Vector3 } from 'three';
import { WxArcVO } from '@article/model/vo/wx-article.vo';
import { CommonConstants } from '@3d-scene/constants/common-constants';

export class WxArc extends WxShape {
  private readonly angle: number;
  private readonly radius: number;

  private points: Vector3[] = [];
  private sides: number = 16;

  public constructor(element: WxArcVO = null) {
    super();
    if (element) {
      this.angle = element.angle != 0 && !isNaN(element.angle) ? element.angle * CommonConstants.COMMON_RADIANS_MULTIPLIER / CommonConstants.COMMON_SCALE : 2 * Math.PI;
      if (this.angle <= 0) {
        this.angle = 2 * Math.PI - this.angle;
      }
      this.closed = true;
      this.radius = element.radius > 0 ? element.radius * CommonConstants.COMMON_SCALE : 10;
      this.calcPoints();
    }
  }

  private calcPoints(): void {
    for (let i: number = 0; i < this.sides; i++) {
      const a: number = i * (this.angle / this.sides);
      this.points.push(new Vector3(-this.round(Math.cos(a) * this.radius), 0, this.round(Math.sin(a) * this.radius)));
    }
  }

  private round(num: number): number {
    return Math.round(num * 1000) / 1000;
  }

  public getPoints(): Vector3[] {
    return this.points;
  }

  public getRadius(): number {
    return this.radius;
  }
}
